/**
 * It takes an email and a token, and returns an array of objects.
 * @param email - email,
 * @param token - the token that is returned from the login API
 * @returns An array of objects.
 */
export const getOrdersByEmail = async (email, token) => {
  let headers = new Headers();
  headers.append('Authorization', 'Bearer ' + token);
  headers.append('Content-Type', 'application/json');
  var raw = JSON.stringify({
    email: email,
  });
  var requestOptions = {
    method: 'POST',
    headers: headers,
    body: raw,
    redirect: 'follow',
  };
  const url = process.env.REACT_APP_ADMIN_API_URL + `/orders/customerOrdersByEmail`;
  const resp = await fetch(url, requestOptions);
  const response = await resp.json();
  const result = response.map(resp => {
    return {
      orderID: resp.order_id,
      externalOrderId: resp.external_order_id,
      deliveryDate: resp.delivery_date,
      orderTotal: resp.order_total,
    };
  });
  return result;
};
